angular.module('bribac.components.organizationEditor', [
  'bribac.translations',
  'bribac.values'
])

  .component('organizationEditor', {
    templateUrl: 'organization-editor-component.html',
    controller: 'OrganizationEditorComponentCtrl',
    bindings: {
      form: '<',
      organization: '<'
    }
  })

  .controller('OrganizationEditorComponentCtrl', function(
    BAC_UNITS
  ) {
    var $ctrl = this

    $ctrl.BAC_UNITS = Object.keys(BAC_UNITS).map(function(key) {
      return BAC_UNITS[key]
    })

    $ctrl.LICENSE_TYPES = [
      'PRO',
      'PRO GROUP',
    ]

    $ctrl.unlistedSettings = [
      'licenseType',
      'licenseInvoiceLimits',
    ]
  })
